module.exports = __webpack_public_path__ + "img/tursab-dds-8127.98f368b9.png";